export default {"src":"/_next/static/media/dark.8be47118.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};